import { PixelPlaceholderLoader, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { generateAutomationName } from "../../../helpers/helpers";
import GAIcon from "../GAIcon/GAIcon";

import { PLACEHOLDER_HEIGHT, PLACEHOLDER_WIDTH } from "./constants";
import * as SC from "./styles";

interface IConnectGAButtonProps {
    onClick: () => void;
    isAvailable?: boolean;
    isConnected?: boolean;
    isLoading?: boolean;
    isGAConnectionsListLoading?: boolean;
}

const ConnectGAButton = ({
    onClick,
    isAvailable,
    isConnected,
    isLoading,
    isGAConnectionsListLoading,
}: IConnectGAButtonProps) => (
    <SC.ButtonWithIconWrapper>
        {isLoading ? (
            <PixelPlaceholderLoader
                width={PLACEHOLDER_WIDTH}
                height={PLACEHOLDER_HEIGHT}
            />
        ) : (
            <>
                <GAIcon
                    isAvailable={isAvailable ?? false}
                    isConnected={isConnected ?? false}
                />
                <PlainTooltip
                    placement="top"
                    enabled={!isAvailable}
                    tooltipContent={translate("bt.report.connect.ga.btn.disabled.tooltip")}
                >
                    <span>
                        <SC.GAButton
                            data-automation={generateAutomationName("report", ["header", "connect", "GA", "button"])}
                            type={isConnected ? "flat" : "outlined"}
                            isDisabled={!isAvailable || isConnected}
                            onClick={onClick}
                            isLoading={isGAConnectionsListLoading}
                        >
                            {isConnected
                                ? translate("bt.report.connect.ga.btn.connected.text")
                                : translate("bt.report.connect.ga.btn.text")}
                        </SC.GAButton>
                    </span>
                </PlainTooltip>
            </>
        )}
    </SC.ButtonWithIconWrapper>
);

export default ConnectGAButton;
